import React from "react";
import { useTranslation } from "../../utils/hooks/translateHook";
import "./Contact.css";

function ContactUs() {
  const t = useTranslation();
  const handleSubmit = async (e) => { e.preventDefault();
    const formData = new FormData(e.target);
    const payload = {
      name: formData.get("name"),
      lastname: formData.get("lastname"),
      email: formData.get("email"),
      message: formData.get("message"),
    };
    try {
      const res = await fetch( "https://myworker.workes.dev/contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json", },
          body: JSON.stringify(payload),
        }
      );
      if (!res.ok) {
        throw new Error("Failed to send message");
      }
      alert(t("contactSuccess"));
      e.target.reset();
    } catch (err) {
      console.error(err);
      alert(t("contactError"));
    }
  };

  return (
    <section className="contactus">
      <div className="contact-card">
        <div className="contact-info">
          <span className="contact-eyebrow"> {t("contactEyebrow")} </span>
          <h1> {t("contactTitle")} </h1>
          <p className="contact-description"> {t("contactDescription")} </p>
          <div className="contact-highlight">
            <span></span>
            <p>{t("contactHighlight")}</p>
          </div>
        </div>
        <div className="formContainer">
          <form
            id="form-request"
            className="contactForm"
            onSubmit={handleSubmit}
          >
            <h2>{t("contactFormTitle")}</h2>
            <div className="contactForm-container">

              <div className="formElement-container">
                <label className="formElement" htmlFor="firstName">
                  {t("name")}
                </label>
                <input
                  name="name"
                  type="text"
                  className="input-default"
                  id="firstName"
                  placeholder={t("name")}
                  required
                />
              </div>

              <div className="formElement-container">
                <label className="formElement" htmlFor="lastName">
                  {t("lastName")}
                </label>
                <input
                  name="lastname"
                  type="text"
                  className="input-default"
                  id="lastName"
                  placeholder={t("lastName")}
                  required
                />
              </div>

              <div className="formElement-container">
                <label className="formElement" htmlFor="email">
                  {t("email")}
                </label>
                <input
                  name="email"
                  type="email"
                  className="input-default"
                  id="email"
                  placeholder={t("email")}
                  required
                />
              </div>

              <div className="formElement-container elementColumn">
                <label className="formElement" htmlFor="message">
                  {t("message")}
                </label>
                <textarea
                  rows={6}
                  name="message"
                  className="input-default"
                  id="message"
                  placeholder={t("messageContent")}
                  required
                />
              </div>

              <button type="submit" className="contact-submit-button">
                {t("send")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;